export interface FormCheckBoxSingle {
  className?: string
  inputClassName?: string
  name?: string
  id?: string
  ariaDescribedby?: string
  children?: JSX.Element
  checked?: boolean
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
}

export const FormCheckBoxSingle = ({
  onChange = () => true,
  name,
  children,
  checked = false,
}: FormCheckBoxSingle) => {
  return (
    <div className='form-check-default box-checkbox'>
      <input
        className='form-checkbox-input'
        id={name}
        type='checkbox'
        name={name}
        checked={checked}
        onChange={onChange}
      />
      <label className='form-checkbox-label' htmlFor={name}>
        {children}
      </label>
    </div>
  )
}
